exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-v-0feaac21],html[data-v-0feaac21]{height:100%}img[data-v-0feaac21]{max-width:400px}.error-page__actions[data-v-0feaac21]{display:flex;justify-content:center;gap:.75rem;flex-wrap:wrap}", ""]);

// exports
